import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { selectMetadataKeyByRegion } from 'reducers/selectors/metadata';

const PosterTitle = ({ item, size }) => {
  const { title, proveedor_name } = item;
  const titleConfig = useSelector(
    selectMetadataKeyByRegion('poster_title_configuration'),
  );
  const direction = (size.width > 768 && 'horizontal') || 'vertical';
  const normalizeProvider = proveedor_name.toLowerCase().replace(' ', '');
  const titleProviderConfig =
    titleConfig[normalizeProvider] || titleConfig.default;

  const titleEnable = titleProviderConfig[direction];
  return (titleEnable && <div className="posterTitle">{title}</div>) || <></>;
};

PosterTitle.propTypes = {
  item: PropTypes.shape({
    title: PropTypes.string,
    provider: PropTypes.string,
    orientation: PropTypes.string,
  }).isRequired,
};

export default PosterTitle;
